import React from "react";
import { BTN_TYPES } from "@/utils/constants";

type ButtonProps = {
  onClickFn?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  btnType?: string;
  children: React.ReactNode;
  disabled?: boolean;
  /** Working on the click (an add in flight): announced, not disabled. */
  busy?: boolean;
  customClasses?: string;
  refs?: React.Ref<HTMLButtonElement>;
  onMouseEnter?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const Button: React.FC<ButtonProps> = ({
  onClickFn,
  btnType = BTN_TYPES.PRIMARY,
  children,
  disabled = false,
  busy = false,
  customClasses,
  refs = null,
  onMouseEnter,
  onMouseLeave,
}) => {
  const btnClass =
    btnType === BTN_TYPES.PRIMARY ? "btn-primary" : "btn-secondary";

  return (
    <button
      className={`group ${btnClass} ${customClasses}`}
      onClick={onClickFn}
      disabled={disabled}
      aria-busy={busy}
      ref={refs}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </button>
  );
};

export default Button;

/*
================================================
Button Component Usage
================================================

import { Button } from "@/components/common";
import { BTN_TYPES } from "@/utils/constants";


<Button
  onClickFn={onClickCallabackFunction}
  btnType={BTN_TYPES.PRIMARY || BTN_TYPES.SECONDARY}
>
  // button content and its hover states
  <div className="text-legacy-primary group-hover:text-legacy-white group-disabled:text-legacy-disable">
    Reserve Your Matic
  </div>
</Button>

*/
